module.exports = __webpack_public_path__ + "static/media/Lato-Hairline.cc02ace7.eot";